import React, { useState, createContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { durations } from '../constants';

export const CarouselContext = createContext({
  isRotating: false,
  revealAnimationDone: false,
});

let rotatingTimeout = undefined;

const Carouselrovider = ({ children }) => {
  const [isRotating, setIsRotating] = useState(false);
  const [revealAnimationDone, setRevealAnimationDone] = useState(false);

  const valueProps = {
    isRotating,
    setIsRotating,
    revealAnimationDone,
    setRevealAnimationDone,
  };

  useEffect(() => {
    if (isRotating) {
      clearTimeout(rotatingTimeout);

      rotatingTimeout = setTimeout(() => {
        setIsRotating(false);
      }, durations.carouselRotationDuration);
    }
  }, [isRotating]);

  return (
    <CarouselContext.Provider value={valueProps}>
      {children}
    </CarouselContext.Provider>
  );
};

Carouselrovider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Carouselrovider;
